/* tslint:disable */

import { ApplicationRef, NgModuleRef } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';
import { IEnvironment } from './model';

// Error.stackTraceLimit = Infinity;
// require('zone.js/dist/long-stack-trace-zone');

export const environment: IEnvironment = {
  // production: false,
  // mainUrl: "http://localhost:5123/api",
  // clientUrl: "http://localhost:3000/#",
  // sourceUrl: "http://localhost:3001/#",
  // rfiUrl: "http://localhost:3001/#",
  // contractUrl: "http://localhost:3001/#",
  // reporterUrl: "http://localhost:3001/#",
  // networkOptimizerUrl: "http://localhost:3001/#",
  // loginUrl: "http://localhost:4200",
  // authServiceUrl: "http://localhost:5223/auth",
  // fileServerUrl: "http://localhost:3123/fs",
  // newsServerUrl: "http://localhost:5123/api",
  // mailServerUrl: "http://localhost:3001/mail",
  // notificationServerUrl: "ws://localhost:3126",
  // notificationServerEndpointUrl: "http://localhost:3127",
  // tollToolUrl: "http://localhost:3001/#",
  // showDevModule: true,


  production: true,
  mainUrl: "https://api.u-tender.net:443/api",
  clientUrl: "https://app.u-tender.net/#",
  sourceUrl: "https://source.u-tender.net/#",
  rfiUrl: "https://rfi.u-tender.net/#",
  contractUrl: "https://contract.u-tender.net/#",
  reporterUrl: "https://reporter.u-tender.net/#",
  networkOptimizerUrl: "https://netoptimizer.u-tender.net/#",
  loginUrl: "https://login.u-tender.net",
  fileServerUrl: "https://service.u-tender.net:443/fs",
  newsServerUrl: "https://api.u-tender.net:443/api",
  authServiceUrl: "https://api.u-tender.net:443/auth",
  mailServerUrl: "https://service.u-tender.net:443/mail",
  notificationServerUrl: "wss://service.u-tender.net:443/notifyws/",
  notificationServerEndpointUrl: "https://service.u-tender.net:443/api",
  tollToolUrl: "https://tolltool.u-tender.net/#",
  showDevModule: false,

  /** Angular debug tools in the dev console
   * https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
   * @param modRef
   * @return {any}
   */
  decorateModuleRef(modRef: NgModuleRef<any>) {
    const appRef = modRef.injector.get(ApplicationRef);
    const cmpRef = appRef.components[0];

    let _ng = (<any>window).ng;
    enableDebugTools(cmpRef);
    (<any>window).ng.probe = _ng.probe;
    (<any>window).ng.coreTokens = _ng.coreTokens;
    return modRef;
  },
  ENV_PROVIDERS: [

  ]
};

